import { useState } from 'react'

export const LAYOUT_MODES = {
  MOBILE: 'mobile',
  MONITOR: 'monitor'
}

// Default is always 1 column (the original mobile-only layout) unless the
// user has explicitly picked monitor before. Falls back to the default for
// any stored value that's no longer valid (e.g. the removed 'tablet' mode).
export const useLayoutMode = () => {
  const [layoutMode, setLayoutModeState] = useState(() => {
    const stored = localStorage.getItem('dashboardLayoutMode')
    return Object.values(LAYOUT_MODES).includes(stored) ? stored : LAYOUT_MODES.MOBILE
  })

  const setLayoutMode = (mode) => {
    setLayoutModeState(mode)
    localStorage.setItem('dashboardLayoutMode', mode)
  }

  return { layoutMode, setLayoutMode }
}
